import {
  getJobLogsAsync
} from "../api/job_logs";

export const getJobLogs = async (jobId) => await getJobLogsAsync(jobId);